import FaqsList from 'components/faqs/FaqsList'
import { useAppSelector } from 'hooks/hooks'
import Card from '../Card'

const ProDashboardView = () => {
    const country = useAppSelector((state) => state.countries.countries[0])
    return (
        <Card header={'FAQs'} icon={'contact_support'} useToggle>
            {country}
            <FaqsList
                key={country}
                filterId={'pro_' + country}
                options={{ category: 'pro', country_code: country }}
                showTopics
            />
        </Card>
    )
}

export default ProDashboardView
